import { DateRange } from 'rewire-common';
import { ITimecard, ResponseFilter } from '../DataTypes';
import infoPanelShiftViewModel, { IInfoPanelShiftViewModelChangeHandler } from './InfoPanelShiftViewModel';
import responsesLogViewModel from './ResponsesLogViewModel';
import { IActionMenuItem } from 'rewire-ui';

export class InfoPanelShiftResponseLogViewModel implements IInfoPanelShiftViewModelChangeHandler {
  optionsActionMenuItems: IActionMenuItem[];
  constructor() {
    this.optionsActionMenuItems = [];
  }

  reset() {
    responsesLogViewModel.reset();
  }

  load = async () => {
    const shift = infoPanelShiftViewModel?.shift?.details?.[0];
    if (!shift) {
      responsesLogViewModel.reset();
      return;
    }
    const effective = new DateRange(shift.earnedDate, shift.earnedDate);

    const filter: ResponseFilter = {
      occupationIds: shift.occupation ? [shift.occupation.id] : undefined,
      effective,
      templateIds: shift.template ? [shift.template.id] : undefined,
    };
    responsesLogViewModel.grid.columns[0].visible = true;
    await responsesLogViewModel.loadResponse([shift] as ITimecard[], filter);
  };

  onCurrentInnerShiftChange() {
    this.load();
  }

  get viewOnly(): boolean {
    return infoPanelShiftViewModel.viewOnly;
  }
}

const infoPanelShiftResponseLogViewModel = new InfoPanelShiftResponseLogViewModel();
export default infoPanelShiftResponseLogViewModel;
